import React from "react";
import { useTranslation } from "react-i18next";
import InfoRow from "./InfoRow";
import InfoSection from "./InfoSection";
import { Col, Row } from "react-bootstrap";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import { useSelector } from "react-redux";
import { useSectionNumbering } from "../hooks/useSectionNumbering";
import GeneralsSection from "./GeneralsSection";

const TotalSummarySection = () => {
	const { t } = useTranslation();
	const supplierInfo = useSelector(selectSupplierInfo);
	const { sectionNumbers } = useSectionNumbering();
	const { amounts, financialSettings } = supplierInfo || { amounts: {} };
	const { generalsBasis } = amounts || {};
	let {
		releasedAmount,
		cashDiscountValue,
		subtotalBeforeVat,
		vatAmount,
		totalGross,
		previousReleasedAmount,
		currentInvoiceAmount,
		subtotalInclDeductionsNet,
		subtotalInclDeductionsGross,
	} = amounts || {
		releasedAmount: 0,
		cashDiscountValue: 0,
		subtotalBeforeVat: 0,
		vatAmount: 0,
		totalGross: 0,
		previousReleasedAmount: 0,
		currentInvoiceAmount: 0,
		subtotalInclDeductionsNet: 0,
		subtotalInclDeductionsGross: 0,
	};
	cashDiscountValue = cashDiscountValue * -1;

	return (
		<InfoSection title="">
			<InfoRow
				label={
					<b>
						{sectionNumbers.releasedInvoiceAmount}.{" "}
						{t("supplier-info.released-invoice-amount")}
					</b>
				}
				value={releasedAmount}
				name="releasedAmount"
				suffix="€"
				isBold={true}
				isNegative={releasedAmount < 0}
			/>
			<Row>
				<Col xs={8}>
					<InfoRow
						label={
							<b>
								{sectionNumbers.cashDiscount}.{" "}
								{t("supplier-info.cash-discount")}
							</b>
						}
						value={financialSettings?.cashDiscount || 0}
						name="cashDiscount"
						suffix="%"
						isBold={true}
					/>
				</Col>
				<Col xs={4}>
					<InfoRow
						label=""
						value={cashDiscountValue || 0}
						isNegative={cashDiscountValue < 0}
						name="discountValue"
						suffix="€"
						isBold={true}
					/>
				</Col>
			</Row>
			<InfoRow
				label={`${sectionNumbers.subtotal}. ${t("supplier-info.subtotal")}`}
				value={subtotalBeforeVat || 0}
				isTotal={true}
				name="subtotalBeforeVat"
				suffix="€"
				isNegative={subtotalBeforeVat < 0}
			/>
			{generalsBasis === "net" && (
				<>
					<GeneralsSection
						title={t("supplier-info.generals-basis-net")}
					/>
					<InfoRow
						label={
							<b>
								{sectionNumbers.subtotalInclDeductions}.{" "}
								{t("supplier-info.subtotal-incl-deductions")}
							</b>
						}
						value={subtotalInclDeductionsNet || 0}
						isBold={true}
						name="subtotalInclDeductionsNet"
						suffix="€"
						isNegative={subtotalInclDeductionsNet < 0}
					/>
				</>
			)}
			<Row>
				<Col xs={8}>
					<InfoRow
						label={
							<b>
								{sectionNumbers.vat}. {t("supplier-info.vat")}
							</b>
						}
						value={financialSettings?.vat || 0}
						name="vatRate"
						suffix="%"
						isBold={true}
					/>
				</Col>
				<Col xs={4}>
					<InfoRow
						label=""
						value={vatAmount || 0}
						name="vatAmount"
						suffix="€"
						isBold={true}
						isNegative={vatAmount < 0}
					/>
				</Col>
			</Row>
			<InfoRow
				label={
					<b>
						{sectionNumbers.subtotal1}.{" "}
						{t("supplier-info.subtotal1")}
					</b>
				}
				value={totalGross || 0}
				isBold={true}
				isTotal={true}
				name="subtotalBeforeVat"
				suffix="€"
				isNegative={totalGross < 0}
			/>
			{generalsBasis === "gross" && (
				<>
					<GeneralsSection
						title={t("supplier-info.generals-basis-gross")}
					/>
					<InfoRow
						label={
							<b>
								{sectionNumbers.subtotalInclDeductions}.{" "}
								{t("supplier-info.subtotal-incl-deductions")}
							</b>
						}
						value={subtotalInclDeductionsGross || 0}
						isBold={true}
						name="subtotalInclDeductionsGross"
						suffix="€"
						isNegative={subtotalInclDeductionsGross < 0}
					/>
				</>
			)}

			<InfoRow
				label={`${sectionNumbers.releasedInstalmentPayments}. ${t("supplier-info.released-instalment-payments")}`}
				value={previousReleasedAmount || 0}
				isTotal={true}
				name="totalGross"
				suffix="€"
				isNegative={previousReleasedAmount < 0}
			/>
			<InfoRow
				label={
					<b>
						{sectionNumbers.totalGross}.{" "}
						{t("supplier-info.total-gross")}
					</b>
				}
				value={currentInvoiceAmount || 0}
				isBold={true}
				isTotal={true}
				name="totalGross"
				suffix="€"
				isNegative={currentInvoiceAmount < 0}
			/>
		</InfoSection>
	);
};

export default TotalSummarySection;
